import { render, staticRenderFns } from "./InterestCertificateList.vue?vue&type=template&id=1f882bcd&scoped=true"
import script from "./InterestCertificateList.vue?vue&type=script&lang=ts"
export * from "./InterestCertificateList.vue?vue&type=script&lang=ts"
import style0 from "./InterestCertificateList.vue?vue&type=style&index=0&id=1f882bcd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f882bcd",
  null
  
)

export default component.exports